import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written',
  name: "Which of the following topics are included within the facility's written policies and procedures?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RECRUITMENT_AND_HIRING',
      text: 'Recruitment and hiring',
      externalIds: [
        {
          id: 'ms-1--2-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing recruitment and hiring:',
        externalIds: [
          {
            id: 'ms-1--2-1f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'TERMINATION_AND_RETRENCHMENT',
      text: 'Termination and retrenchment',
      externalIds: [
        {
          id: 'ms-1--2-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing termination and retrenchment:',
        externalIds: [
          {
            id: 'ms-1--2-2f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FACILITY_WORKPLACE_RULES',
      text: 'Facility workplace rules',
      externalIds: [
        {
          id: 'ms-1--2-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing facility workplace rules:',
        externalIds: [
          {
            id: 'ms-1--2-3f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'CHILD_LABOR_AND_OR_YOUNG_WORKERS',
      text: 'Child labor and/or young workers',
      externalIds: [
        {
          id: 'ms-1--2-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing child labor and/or young workers:',
        externalIds: [
          {
            id: 'ms-1--2-4f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'PROHIBITION_OF_FORCED_LABOR',
      text: 'Prohibition of forced labor',
      externalIds: [
        {
          id: 'ms-1--2-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing prohibition of forced labor:',
        externalIds: [
          {
            id: 'ms-1--2-5f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'ANTI_HARASSMENT_AND_ABUSE',
      text: 'Anti-harassment and abuse',
      externalIds: [
        {
          id: 'ms-1--2-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing anti-harassment and abuse:',
        externalIds: [
          {
            id: 'ms-1--2-6f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'ANTI_DISCRIMINATION',
      text: 'Anti-discrimination',
      externalIds: [
        {
          id: 'ms-1--2-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing anti-discrimination:',
        externalIds: [
          {
            id: 'ms-1--2-7f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WORKING_HOURS',
      text: 'Working hours',
      externalIds: [
        {
          id: 'ms-1--2-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing working hours:',
        externalIds: [
          {
            id: 'ms-1--2-8f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WAGES_AND_BENEFITS',
      text: 'Wages and benefits',
      externalIds: [
        {
          id: 'ms-1--2-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing wages and benefits:',
        externalIds: [
          {
            id: 'ms-1--2-9f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'DISCIPLINE',
      text: 'Discipline',
      externalIds: [
        {
          id: 'ms-1--2-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing discipline:',
        externalIds: [
          {
            id: 'ms-1--2-10f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
      text: 'Freedom of association and collective bargaining',
      externalIds: [
        {
          id: 'ms-1--2-11x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing freedom of association and collective bargaining:',
        externalIds: [
          {
            id: 'ms-1--2-11f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'GRIEVANCE_SYSTEMS',
      text: 'Grievance systems',
      externalIds: [
        {
          id: 'ms-1--2-12x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing grievance systems:',
        externalIds: [
          {
            id: 'ms-1--2-12f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'WORKER_FEEDBACK',
      text: 'Worker feedback',
      externalIds: [
        {
          id: 'ms-1--2-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing worker feedback:',
        externalIds: [
          {
            id: 'ms-1--2-13f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'HEALTH_AND_SAFETY',
      text: 'Health and safety',
      externalIds: [
        {
          id: 'ms-1--2-14x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing health and safety:',
        externalIds: [
          {
            id: 'ms-1--2-14f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FOREIGN_MIGRANT_WORKERS',
      text: 'Foreign migrant workers',
      externalIds: [
        {
          id: 'ms-1--2-16x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing foreign migrant workers:',
        externalIds: [
          {
            id: 'ms-1--2-16f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'DOMESTIC_MIGRANT_WORKERS',
      text: 'Domestic migrant workers',
      externalIds: [
        {
          id: 'ms-pla-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing domestic migrant workers:',
        externalIds: [
          {
            id: 'ms-pla-8f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'HOMEWORKERS',
      text: 'Homeworkers',
      externalIds: [
        {
          id: 'ms-1--2-17x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing homeworkers:',
        externalIds: [
          {
            id: 'ms-1--2-17f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SUPPLIERS_SUBCONTRACTORS',
      text: 'Suppliers/subcontractors',
      externalIds: [
        {
          id: 'ms-1--2-18x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing suppliers/subcontractors:',
        externalIds: [
          {
            id: 'ms-1--2-18f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'RAW_MATERIALS_SOURCING',
      text: 'Raw materials sourcing',
      externalIds: [
        {
          id: 'ms-pla-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing raw materials sourcing:',
        externalIds: [
          {
            id: 'ms-pla-10f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'BRIBERY_AND_ANTI_CORRUPTION',
      text: 'Bribery and anti-corruption',
      externalIds: [
        {
          id: 'ms-1--2-19x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please provide a list of all written policies and procedures referencing Bribery and anti-corruption:',
        externalIds: [
          {
            id: 'ms-1--2-19f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--2-20x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe and provide a list of the relevant written policies and procedures:',
        externalIds: [
          {
            id: 'ms-1--2-20f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RECRUITMENT_AND_HIRING',
                'TERMINATION_AND_RETRENCHMENT',
                'FACILITY_WORKPLACE_RULES',
                'CHILD_LABOR_AND_OR_YOUNG_WORKERS',
                'PROHIBITION_OF_FORCED_LABOR',
                'ANTI_HARASSMENT_AND_ABUSE',
                'ANTI_DISCRIMINATION',
                'WORKING_HOURS',
                'WAGES_AND_BENEFITS',
                'DISCIPLINE',
                'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
                'GRIEVANCE_SYSTEMS',
                'WORKER_FEEDBACK',
                'HEALTH_AND_SAFETY',
                'FOREIGN_MIGRANT_WORKERS',
                'DOMESTIC_MIGRANT_WORKERS',
                'HOMEWORKERS',
                'SUPPLIERS_SUBCONTRACTORS',
                'RAW_MATERIALS_SOURCING',
                'BRIBERY_AND_ANTI_CORRUPTION',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-6',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 18330,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
